import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/atmolab_server_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    return {
      dialogFormVisible: false,
      formData: {
        team_id: ''
      },
      tabledata: [],
      coachType: {
        'head': '主教练',
        'assistant': '助理教练',
        'player': '球员兼教练',
        'leader': '领队'
      }
    };
  },
  computed: {},
  created: function created() {},
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (data) {
                  _this.formData.team_id = data;

                  _this.getCoachesListFn();
                }

                _this.dialogFormVisible = true;

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getCoachesListFn: function getCoachesListFn() {
      var _this2 = this;

      this.$api.teamByCoachesList({
        team_id: this.formData.team_id,
        page: 1,
        page_size: 1000
      }).then(function (res) {
        if (res.code == 200) {
          _this2.tabledata = res.data.data;
        }
      });
    }
  }
};